import { CancelablePromise } from 'cancelable-promise';
import { File, Folder, davParsePermissions, davGetDefaultPropfind } from '@nextcloud/files';
import { generateRemoteUrl } from '@nextcloud/router';
import { getCurrentUser } from '@nextcloud/auth';
import { getClient, rootPath } from './WebdavClient';
import { hashCode } from '../utils/hashUtils';
import logger from '../logger';
const client = getClient();
export const resultToNode = function (node) {
    const props = node.props;
    const permissions = davParsePermissions(props?.permissions);
    const owner = getCurrentUser()?.uid;
    const source = generateRemoteUrl('dav' + rootPath + node.filename);
    const id = props?.fileid < 0
        ? hashCode(source)
        : props?.fileid || 0;
    const nodeData = {
        id,
        source,
        mtime: new Date(node.lastmod),
        mime: node.mime,
        size: props?.size || 0,
        permissions,
        owner,
        root: rootPath,
        attributes: {
            ...node,
            ...props,
            hasPreview: props?.['has-preview'],
            failed: props?.fileid < 0,
        },
    };
    delete nodeData.attributes.props;
    return node.type === 'file'
        ? new File(nodeData)
        : new Folder(nodeData);
};
export const getContents = (path = '/') => {
    const controller = new AbortController();
    const propfindPayload = davGetDefaultPropfind();
    return new CancelablePromise(async (resolve, reject, onCancel) => {
        onCancel(() => controller.abort());
        try {
            const contentsResponse = await client.getDirectoryContents(path, {
                details: true,
                data: propfindPayload,
                includeSelf: true,
                signal: controller.signal,
            });
            const root = contentsResponse.data[0];
            const contents = contentsResponse.data.slice(1);
            if (root.filename !== path) {
                throw new Error('Root node does not match requested path');
            }
            resolve({
                folder: resultToNode(root),
                contents: contents.map(result => {
                    try {
                        return resultToNode(result);
                    }
                    catch (error) {
                        logger.error(`Invalid node detected '${result.basename}'`, { error });
                        return null;
                    }
                }).filter(Boolean),
            });
        }
        catch (error) {
            reject(error);
        }
    });
};
